module.exports = __webpack_public_path__ + "media/02-Cancelar-Picking.5a13e0f4.mp4";